import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';

export default class CalendarHero extends Component {
  view() {
    return (
      <header className="Hero CalendarHero">
        <div className="container">
          <div className="containerNarrow">
            <h1 className="Hero-title">
              <i className="icon fas fa-calendar-alt" />
              {' '}
              {app.translator.trans('kemze-calendar.forum.button.landing')}
            </h1>
          </div>
        </div>
      </header>
    );
  }
}
